import React from "react";

/**
 * Moonbucks logo — coffee-mug body with three ascending bars where the steam used to be.
 * Plays the "chart going up" metaphor while staying rooted in the coffee mark.
 *
 * Props:
 *   className    — sizing/coloring container (defaults to 1em)
 *   strokeWidth  — line thickness (default 2 to match Lucide)
 *   barColor     — override bar fill (default = currentColor)
 */
export default function MoonbucksLogo({
  className = "w-6 h-6",
  strokeWidth = 2,
  barColor,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      data-testid="moonbucks-logo"
      {...props}
    >
      {/* Cup body — rounded base with the inside hollow (matches Lucide Coffee mug) */}
      <path d="M17 8h1a4 4 0 0 1 0 8h-1" />
      <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" />

      {/* Three ascending "steam → chart" bars: short, medium, tall (left → right).
          Drawn as filled rounded bars so they read as chart bars, not wavy steam. */}
      <rect x="5.5"  y="5" width="2" height="2" rx="0.6" fill={barColor || "currentColor"} stroke="none" />
      <rect x="9"    y="3" width="2" height="4" rx="0.6" fill={barColor || "currentColor"} stroke="none" />
      <rect x="12.5" y="1" width="2" height="6" rx="0.6" fill={barColor || "currentColor"} stroke="none" />
    </svg>
  );
}
